import { createReducer } from '@reduxjs/toolkit';

import type { Status } from '../../constants';
import { getConnectionStatus } from '../../utils/getConnectionStatus';
import { updateNetworkStatus } from '../actions';

const initialState: {
    status: Status;
} = {
    status: getConnectionStatus(),
};

export const reducer = createReducer(initialState, builder => {
    builder.addCase(updateNetworkStatus, (state, action) => {
        state.status = action.payload;
    });
});
